module.exports = __webpack_public_path__ + "static/media/img_foncia.688b28ea.png";